export enum CalendarOperation {
    DeleteCalendar, // 0
    RenameCalendar, // 1
    SetCalendarHexColor, // 2
    SetCalendarColor, // 3
    UpdateCalendarCharm, // 4
    GetUserAvailability,
}
